<script>
    export default {
        name: 'CourseCardItem',
        props: {
            courseprop: {
                type: Object,
                required: true
            },
            isDetail: {
                type: Boolean,
                required: false
            },
            insideMap: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                days: [
                    {name: 'L', long: 'Lunedì'},
                    {name: 'M', long: 'Martedì'},
                    {name: 'M', long: 'Mercoledì'},
                    {name: 'G', long: 'Giovedì'},
                    {name: 'V', long: 'Venerdì'},
                    {name: 'S', long: 'Sabato'},
                    {name: 'D', long: 'Domenica'}
                ],
                tempTags: [
                    {icon: 'fa-map-marker-alt', text: 'A 10 minuti da te', color: 'orangogo'},
                    {icon: 'fa-tag', text: '-30% sconto', color: 'primary'}
                ],
                reviews_avg_score: 0,
                course: null
            }
        },
        mounted() {


        },
        created() {
            this.course = this.courseprop;
            this.reviews_avg_score = this.course.reviews_avg_score;
            if (!this.course.days) this.course.days = []
            for (const day of this.days) {
                const lesson = this.course.days.find(les => les.day.toLowerCase() === day.long.toLowerCase());
                if (lesson) {
                    day.lesson = true;
                }
            }
        },
        methods: {
            loadFilteredCourses(courses) {
                this.course = courses
            },
            getCourseDistance(course) {
                if (course.distance_from_my_position < 1)
                    return (course.distance_from_my_position * 1000) + " m";
                return Math.round(course.distance_from_my_position) + " km";
            },
            hrefCourse(course) {
                return `/corsi/${course.slug}`;
            },
            courseSeoName(course){
                return `Corso di ${course.sport.name} - ${course.start_age} / ${course.end_age} anni`
            },
            courseAddress(course){
                return course.municipality + ", " + course.route + " " + course.house_number;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/course/CourseCardItem.vue